import { render } from "./ParentsSalon.vue?vue&type=template&id=ca5c4dc8"
import script from "./ParentsSalon.vue?vue&type=script&lang=js"
export * from "./ParentsSalon.vue?vue&type=script&lang=js"

import "./ParentsSalon.vue?vue&type=style&index=0&id=ca5c4dc8&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__